module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-scrollDiv', {
    staticClass: "base-page"
  }, [_c('div', {
    staticClass: "base-head",
    class: {
      border: _vm.pop
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pop),
      expression: "pop"
    }],
    staticClass: "return",
    attrs: {
      "src": require("assets/image/back-return.svg")
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title",
    attrs: {
      "title": _vm.title
    }
  }, [_vm._v(_vm._s(_vm._f("titleLimit")(_vm.title)))]), _vm._v(" "), _vm._t("tab-title")], 2), _vm._v(" "), _c('div', {
    staticClass: "base-main"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-6c469092!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/global/basePage.vue
// module id = 759
// module chunks = 1